import React, { Component } from 'react';
import FontAwesome from 'react-fontawesome';

class FooterSection extends Component {
  render() {
    return (
      <div className="row footer justify-content-center align-items-center mt-4">
        <a href="https://www.instagram.com/alessiomantelli_editor/" className="opacity" target="_blank">
          <FontAwesome
            className="social-icon mx-2"
            name='instagram'
            size='2x'
          />
        </a>
        <a href="https://www.linkedin.com/in/alessiomantelli/" className="opacity" target="_blank">
          <FontAwesome
            className="social-icon mx-2"
            name='linkedin'
            size='2x'
          />
        </a>
        <a href="https://www.facebook.com/almantelli/" className="opacity" target="_blank">
          <FontAwesome
            className="social-icon mx-2"
            name='facebook-square'
            size='2x'
          />
        </a>
        {/* <a href="" className="opacity" target="_blank">
          <FontAwesome
            className="social-icon mx-2"
            name='instagram'
            size='2x'
          />
        </a> */}
      </div>
    );
  }
}

export default FooterSection ;



// WEBPACK FOOTER //
// ./src/components/FooterSection.js